import Api from './main';
export { http, getMedia } from './main';
/* istanbul ignore next */

Api.install = function (Vue, config) {
  if (config === void 0) {
    config = {};
  }

  if (typeof Vue === 'object') {
    config = Vue;
  }

  Api.setConfig(config);
};

export default Api;